import React, { useState, useEffect } from "react";
import fileIsImage from "../../utils/fileIsImage";

import LoadedFileText from "../loaded-file-text/loaded-file-text";
import Picture from "../picture/picture";

const Attachment = ({ uploadedFileText, loadPreview, onDelete, getFile }) => {
	const fileIsPicture = fileIsImage(uploadedFileText);
	const [previewError, setPreviewError] = useState();
	const [previewURL, setPreviewURL] = useState();
	useEffect(() => {
		(async () => {
			if (fileIsPicture && uploadedFileText) {
				const preview = await loadPreview();
				if (preview) {
					const content = Buffer.from(preview, "base64");
					const blob = new Blob([content]);
					setPreviewURL(window.URL.createObjectURL(blob));
				} else {
					setPreviewError("previewError");
				}
			}
		})();
	}, [fileIsPicture, uploadedFileText]);

	if (!fileIsPicture || previewError) {
		return (
			<LoadedFileText
				uploadedFileText={uploadedFileText}
				onDelete={onDelete}
				onSave={async () => {
					const downloadUrl = await getFile();
					const link = document.createElement("a");
					link.href = downloadUrl;
					link.download = uploadedFileText;
					document.body.appendChild(link);
					link.click();
					link.remove();
				}}
			/>
		);
	}
	if (fileIsPicture && !previewError) {
		return (
			<Picture
				getFile={getFile}
				onDelete={onDelete}
				previewURL={previewURL}
				name={uploadedFileText}
			/>
		);
	}

	return null;
};

export default Attachment;
